// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from "react";
// import logo from '../assets/img/logo-white.png';
// import {Link} from 'react-router-dom'
// import { HashLink  } from 'react-router-hash-link';

// const Navbar = () => {
//   const onToggle = () => {
//     let navbarid = document.getElementById("navbar");
//     navbarid.classList.toggle("navbar-mobile");
//   };

//   const ToggleButton = () => {
//     let navbar = document.getElementById("navbar");
//     if (navbar.classList.contains("navbar-mobile")) {
//       navbar.classList.remove("navbar-mobile");
//       let navbarToggle = document.getElementById("toggle-button");
//       navbarToggle.classList.add("bi-list");
//     }
//   };

//   const ToggleDropDown= (e)=>{
//     e.preventDefault()
//     let drop_down_active = e.currentTarget.nextElementSibling
//     drop_down_active.classList.toggle('dropdown-active')
//   }
  
//   return (
//     <>
//       <header id="header" className="fixed-top d-flex align-items-center">
//         <div className="container d-flex align-items-center">
//           <h1 className="logo me-auto primary">
//             <Link to="./">
//               <img src={logo} className="img-fluid" alt="logo"></img>
//               <p className="logo_underx text-white">x=independently organized <span  style={{color: "red"}}> TED </span>event</p>
//             </Link>
//           </h1>
//           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false"aria-label="Toggle navigation">
//           <span className="navbar-toggler-icon"></span>
//           </button>

//           <nav id="navbar" className="navbar order-last order-lg-0">
//             <ul>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./">Home</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#teaser">Theme</HashLink></li>
//               <li  className="dropdown"><a href="#" onClick={ToggleDropDown}><span>About</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul >
//                   <li  onClick={ToggleButton}><Link to="./about"><span>About Us</span></Link></li>
//                   <li  onClick={ToggleButton}><Link to="./team"><span>TED<sup>x</sup> Team</span></Link></li>
//                   <li  onClick={ToggleButton}><a href="https://www.iitj.ac.in/" target="_blank" rel="noreferrer"><span>IIT Jodhpur</span></a></li>
//                 </ul>  
//               </li>
//               <li className="dropdown"><a onClick={ToggleDropDown} href="#"><span>Speakers</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul>
//                   <li  onClick={ToggleButton}><Link to="./speakers">Our Past Speakers</Link></li>
//                   <li  onClick={ToggleButton}><Link to="./recentspeakers">New Speakers</Link></li>
//                   <li  onClick={ToggleButton}> <a href="https://docs.google.com/forms/d/e/1FAIpQLSfemXEg95_e8vxkKPfuepGxiYN2HekYMS-vvAW8e5YpOWrcHg/viewform" target="_blank" rel="noreferrer">Apply To Speak</a></li>
//                 </ul>  
//             </li>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./events">Events</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#contact">Contact us</HashLink></li>
//             </ul>
//             <i className="bi bi-list mobile-nav-toggle" onClick={onToggle} id="toggle-button"></i>
//           </nav>
//           <a href="https://forms.gle/Cf5uTZcrViPhSjuN8" target="_blank" rel="noreferrer" className="get-started-btn scrollto">Get Tickets</a>
//         </div>
//       </header>
     
//     </>
//   );
// };

// export default Navbar;








// import React, { useState } from "react";
// import logo from '../assets/img/logo-white.png';
// import { Link } from 'react-router-dom';
// import { HashLink } from 'react-router-hash-link';
// import { auth, provider } from '../firebase/firebaseConfig'; 
// import { signInWithPopup, signOut as firebaseSignOut } from "firebase/auth";

// const Navbar = () => {
//   const [user, setUser] = useState(null); // State to hold user info

//   const onToggle = () => {
//     let navbarid = document.getElementById("navbar");
//     navbarid.classList.toggle("navbar-mobile");
//   };

//   const ToggleButton = () => {
//     let navbar = document.getElementById("navbar");
//     if (navbar.classList.contains("navbar-mobile")) {
//       navbar.classList.remove("navbar-mobile");
//       let navbarToggle = document.getElementById("toggle-button");
//       navbarToggle.classList.add("bi-list");
//     }
//   };

//   const ToggleDropDown = (e) => {
//     e.preventDefault();
//     let drop_down_active = e.currentTarget.nextElementSibling;
//     drop_down_active.classList.toggle('dropdown-active');
//   };

//   // Google Sign-In function
//   const handleGoogleSignIn = async () => {
//     try {
//       // Sign out the previous user
//       await firebaseSignOut(auth);
      
//       // Sign in with popup
//       const result = await signInWithPopup(auth, provider);
//       const user = result.user;
//       console.log("User signed in:", user);
//       setUser(user); // Store user info in state
//       alert(`Welcome ${user.displayName}!`);
//     } catch (error) {
//       console.error("Error during sign-in:", error);
//       alert("Sign-in failed. Please try again.");
//     }
//   };

//   // Sign-out function
//   const handleSignOut = async () => {
//     try {
//       await firebaseSignOut(auth);
//       setUser(null); // Clear user info from state
//       alert("You have signed out.");
//     } catch (error) {
//       console.error("Error during sign-out:", error);
//     }
//   };

//   return (
//     <>
//       <header id="header" className="fixed-top d-flex align-items-center">
//         <div className="container d-flex align-items-center">
//           <h1 className="logo me-auto primary">
//             <Link to="./">
//               <img src={logo} className="img-fluid" alt="logo"></img>
//               <p className="logo_underx text-white">x=independently organized <span style={{ color: "red" }}> TED </span> event</p>
//             </Link>
//           </h1>
//           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <nav id="navbar" className="navbar order-last order-lg-0">
//             <ul>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./">Home</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#teaser">Theme</HashLink></li>
//               <li className="dropdown"><a href="#" onClick={ToggleDropDown}><span>About</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul>
//                   <li onClick={ToggleButton}><Link to="./about"><span>About Us</span></Link></li>
//                   <li onClick={ToggleButton}><Link to="./team"><span>TED<sup>x</sup> Team</span></Link></li>
//                   <li onClick={ToggleButton}><a href="https://www.iitj.ac.in/" target="_blank" rel="noreferrer"><span>IIT Jodhpur</span></a></li>
//                 </ul>
//               </li>
//               <li className="dropdown"><a onClick={ToggleDropDown} href="#"><span>Speakers</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul>
//                   <li onClick={ToggleButton}><Link to="./speakers">Our Past Speakers</Link></li>
//                   <li onClick={ToggleButton}><Link to="./recentspeakers">New Speakers</Link></li>
//                   <li onClick={ToggleButton}> <a href="https://docs.google.com/forms/d/e/1FAIpQLSfemXEg95_e8vxkKPfuepGxiYN2HekYMS-vvAW8e5YpOWrcHg/viewform" target="_blank" rel="noreferrer">Apply To Speak</a></li>
//                 </ul>
//               </li>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./events">Events</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#contact">Contact us</HashLink></li>
//             </ul>
//             <i className="bi bi-list mobile-nav-toggle" onClick={onToggle} id="toggle-button"></i>
//           </nav>
//           <button onClick={user ? handleSignOut : handleGoogleSignIn} className="get-started-btn scrollto">
//             {user ? `Welcome ${user.displayName}` : 'Get Tickets'}
//           </button>
//         </div>
//       </header>
//     </>
//   );
// };

// export default Navbar;


// import React, { useState, useEffect } from "react";
// import logo from '../assets/img/logo-white.png';
// import { Link } from 'react-router-dom';
// import { HashLink } from 'react-router-hash-link';
// import { auth, provider } from '../firebase/firebaseConfig'; 
// import { signInWithPopup, signOut as firebaseSignOut, onAuthStateChanged } from "firebase/auth";
// import { QRCodeCanvas } from "qrcode.react"; 
// import Modal from 'react-modal'; 

// const Navbar = () => {
//   const [user, setUser] = useState(null); 
//   const [modalIsOpen, setModalIsOpen] = useState(false); 
//   const [qrCodeValue, setQrCodeValue] = useState(''); 

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setUser(user); // Set user state based on auth state
//     });

//     return () => unsubscribe(); // Cleanup the subscription on unmount
//   }, []);

//   const onToggle = () => {
//     let navbarid = document.getElementById("navbar");
//     navbarid.classList.toggle("navbar-mobile");
//   };

//   const ToggleButton = () => {
//     let navbar = document.getElementById("navbar");
//     if (navbar.classList.contains("navbar-mobile")) {
//       navbar.classList.remove("navbar-mobile");
//       let navbarToggle = document.getElementById("toggle-button");
//       navbarToggle.classList.add("bi-list");
//     }
//   };

//   const ToggleDropDown = (e) => {
//     e.preventDefault();
//     let drop_down_active = e.currentTarget.nextElementSibling;
//     drop_down_active.classList.toggle('dropdown-active');
//   };

//   const handleGoogleSignIn = async () => {
//     try {
//       const result = await signInWithPopup(auth, provider);
//       const user = result.user;
//       console.log("User signed in:", user);
//       alert(`Welcome ${user.displayName}!`);
//     } catch (error) {
//       console.error("Error during sign-in:", error);
//       alert("Sign-in failed. Please try again.");
//     }
//   };

//   const handleSignOut = async () => {
//     try {
//       await firebaseSignOut(auth);
//       alert("You have signed out.");
//     } catch (error) {
//       console.error("Error during sign-out:", error);
//     }
//   };

//   const handleGetQRCode = () => {
//     if (user) {
//       setQrCodeValue(user.uid); 
//       setModalIsOpen(true); 
//     }
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   return (
//     <>
//       <header id="header" className="fixed-top d-flex align-items-center">
//         <div className="container d-flex align-items-center">
//           <h1 className="logo me-auto primary">
//             <Link to="./">
//               <img src={logo} className="img-fluid" alt="logo"></img>
//               <p className="logo_underx text-white">x=independently organized <span style={{ color: "red" }}> TED </span> event</p>
//             </Link>
//           </h1>
//           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <nav id="navbar" className="navbar order-last order-lg-0">
//             <ul>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./">Home</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#teaser">Theme</HashLink></li>
//               <li className="dropdown"><a href="#" onClick={ToggleDropDown}><span>About</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul>
//                   <li onClick={ToggleButton}><Link to="./about"><span>About Us</span></Link></li>
//                   <li onClick={ToggleButton}><Link to="./team"><span>TED<sup>x</sup> Team</span></Link></li>
//                   <li onClick={ToggleButton}><a href="https://www.iitj.ac.in/" target="_blank" rel="noreferrer"><span>IIT Jodhpur</span></a></li>
//                 </ul>
//               </li>
//               <li className="dropdown"><a onClick={ToggleDropDown} href="#"><span>Speakers</span> <i className="bi bi-chevron-down"></i></a>
//                 <ul>
//                   <li onClick={ToggleButton}><Link to="./speakers">Our Past Speakers</Link></li>
//                   <li onClick={ToggleButton}><Link to="./recentspeakers">New Speakers</Link></li>
//                   <li onClick={ToggleButton}><a href="https://docs.google.com/forms/d/e/1FAIpQLSfemXEg95_e8vxkKPfuepGxiYN2HekYMS-vvAW8e5YpOWrcHg/viewform" target="_blank" rel="noreferrer">Apply To Speak</a></li>
//                 </ul>
//               </li>
//               <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./events">Events</Link></li>
//               <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#contact">Contact us</HashLink></li>
//             </ul>
//             <i className="bi bi-list mobile-nav-toggle" onClick={onToggle} id="toggle-button"></i>
//           </nav>
//           <button onClick={user ? handleSignOut : handleGoogleSignIn} className="get-started-btn scrollto">
//             {user ? `Welcome ${user.displayName.split(' ')[0]}` : 'Get Tickets'}
//           </button>
//           {/* Get QR Code Button */}
//           {user && (
//             <button onClick={handleGetQRCode} className="get-started-btn scrollto">
//               Get QR Code
//             </button>
//           )}
//         </div>
//       </header>

//       {/* Modal for QR Code */}
//       <Modal 
//         isOpen={modalIsOpen} 
//         onRequestClose={closeModal} 
//         ariaHideApp={false} 
//         style={{
//           content: {
//             top: '50%',
//             left: '50%',
//             right: 'auto',
//             bottom: 'auto',
//             transform: 'translate(-50%, -50%)',
//             padding: '20px',
//             borderRadius: '10px', 
//             boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
//           },
//           overlay: {
//             backgroundColor: 'rgba(0, 0, 0, 0.75)'
//           }
//         }}
//       >
//         <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', fontSize: '24px' }}>QR CODE</p>
//         <QRCodeCanvas value={qrCodeValue} size={256} />
//         {/* <button onClick={closeModal} className="get-started-btn scrollto">Close</button> */}
//       </Modal>
//     </>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from "react";
import logo from '../assets/img/logo-white.png';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { auth, provider, database } from '../firebase/firebaseConfig'; // Ensure you import the database
import { signInWithPopup, signOut as firebaseSignOut, onAuthStateChanged } from "firebase/auth";
import { set, ref } from "firebase/database"; // Import necessary functions for Realtime Database
import { QRCodeCanvas } from "qrcode.react"; 
import Modal from 'react-modal'; 

const Navbar = () => {
  const [user, setUser] = useState(null); 
  const [modalIsOpen, setModalIsOpen] = useState(false); 
  const [qrCodeValue, setQrCodeValue] = useState(''); 

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user); // Set user state based on auth state
    });

    return () => unsubscribe(); // Cleanup the subscription on unmount
  }, []);

  const onToggle = () => {
    let navbarid = document.getElementById("navbar");
    navbarid.classList.toggle("navbar-mobile");
  };

  const ToggleButton = () => {
    let navbar = document.getElementById("navbar");
    if (navbar.classList.contains("navbar-mobile")) {
      navbar.classList.remove("navbar-mobile");
      let navbarToggle = document.getElementById("toggle-button");
      navbarToggle.classList.add("bi-list");
    }
  };

  const ToggleDropDown = (e) => {
    e.preventDefault();
    let drop_down_active = e.currentTarget.nextElementSibling;
    drop_down_active.classList.toggle('dropdown-active');
  };

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("User signed in:", user);
      alert(`Welcome ${user.displayName}!`);

      // Create user entry in Realtime Database
      const userRef = ref(database, `users/${user.uid}`); // Create a reference to the user
      await set(userRef, {
        displayName: user.displayName,
        email: user.email,
        status: 'OUT', // Set status to 0
      });
      console.log("User data written to database");
      alert(`Welcome ${user.displayName}!`);
      
    } catch (error) {
      console.error("Error during sign-in:", error);
      alert("Sign-in failed. Please try again.");
    }
  };

  const handleSignOut = async () => {
    try {
      await firebaseSignOut(auth);
      alert("You have signed out.");
    } catch (error) {
      console.error("Error during sign-out:", error);
    }
  };

  const handleGetQRCode = () => {
    if (user) {
      setQrCodeValue(user.uid); 
      setModalIsOpen(true); 
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex align-items-center">
          <h1 className="logo me-auto primary">
            <Link to="./">
              <img src={logo} className="img-fluid" alt="logo"></img>
              <p className="logo_underx text-white">x=independently organized <span style={{ color: "red" }}> TED </span> event</p>
            </Link>
          </h1>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <nav id="navbar" className="navbar order-last order-lg-0">
            <ul>
              <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./">Home</Link></li>
              <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#teaser">Theme</HashLink></li>
              <li className="dropdown"><a href="#" onClick={ToggleDropDown}><span>About</span> <i className="bi bi-chevron-down"></i></a>
                <ul>
                  <li onClick={ToggleButton}><Link to="./about"><span>About Us</span></Link></li>
                  <li onClick={ToggleButton}><Link to="./team"><span>TED<sup>x</sup> Team</span></Link></li>
                  <li onClick={ToggleButton}><a href="https://www.iitj.ac.in/" target="_blank" rel="noreferrer"><span>IIT Jodhpur</span></a></li>
                </ul>
              </li>
              <li className="dropdown"><a onClick={ToggleDropDown} href="#"><span>Speakers</span> <i className="bi bi-chevron-down"></i></a>
                <ul>
                  <li onClick={ToggleButton}><Link to="./speakers">Our Past Speakers</Link></li>
                  <li onClick={ToggleButton}><Link to="./recentspeakers">New Speakers</Link></li>
                  <li onClick={ToggleButton}><a href="https://docs.google.com/forms/d/e/1FAIpQLSfemXEg95_e8vxkKPfuepGxiYN2HekYMS-vvAW8e5YpOWrcHg/viewform" target="_blank" rel="noreferrer">Apply To Speak</a></li>
                </ul>
              </li>
              <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./sponsors">Sponsors</Link></li>
              <li onClick={ToggleButton}><Link className="nav-link scrollto" to="./events">Events</Link></li>
              <li onClick={ToggleButton}><HashLink className="nav-link scrollto" to="/#contact">Contact us</HashLink></li>
            </ul>
            <i className="bi bi-list mobile-nav-toggle" onClick={onToggle} id="toggle-button"></i>
          </nav>
          <button onClick={user ? handleSignOut : handleGoogleSignIn} className="get-started-btn scrollto">
            {/* {user ? `Welcome ${user.displayName.split(' ')[0]}` : 'Get Tickets'} */}
            {user ? `Sign Out` : 'Get Tickets'}

          </button>
          {/* Get QR Code Button */}
          {user && (
            <button onClick={handleGetQRCode} className="get-started-btn scrollto">
              QR Code
            </button>
          )}
        </div>
      </header>

      {/* Modal for QR Code */}
      <Modal 
        isOpen={modalIsOpen} 
        onRequestClose={closeModal} 
        ariaHideApp={false} 
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            borderRadius: '10px', 
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
          }
        }}
      >
        <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', fontSize: '24px' }}>QR CODE</p>
        <QRCodeCanvas value={qrCodeValue} size={256} />
        {/* <button onClick={closeModal} className="get-started-btn scrollto">Close</button> */}
      </Modal>
    </>
  );
};

export default Navbar;

